export const getBehaviourFuelSavingsPerOperatorRespAviation = () => {
  return [
    {
      countEventsPerformablePostSignol: 127,
      countEventsPerformedPostSignol: 25,
      avgNetFuelSavingKgPreSignol: 0.89,
      avgNetFuelSavingKgPostSignol: 15.93,
    },
    {
      countEventsPerformablePostSignol: 127,
      countEventsPerformedPostSignol: 25,
      avgNetFuelSavingKgPreSignol: 1.89,
      avgNetFuelSavingKgPostSignol: 10.93,
    },
    {
      countEventsPerformablePostSignol: 127,
      countEventsPerformedPostSignol: 25,
      avgNetFuelSavingKgPreSignol: 3.89,
      avgNetFuelSavingKgPostSignol: 17.93,
    },
    {
      countEventsPerformablePostSignol: 127,
      countEventsPerformedPostSignol: 25,
      avgNetFuelSavingKgPreSignol: 4.89,
      avgNetFuelSavingKgPostSignol: 25.93,
    },
    {
      countEventsPerformablePostSignol: 127,
      countEventsPerformedPostSignol: 25,
      avgNetFuelSavingKgPreSignol: 7.89,
      avgNetFuelSavingKgPostSignol: 34.93,
    },
    {
      countEventsPerformablePostSignol: 127,
      countEventsPerformedPostSignol: 25,
      avgNetFuelSavingKgPreSignol: 10.89,
      avgNetFuelSavingKgPostSignol: 45.93,
    },
    {
      countEventsPerformablePostSignol: 127,
      countEventsPerformedPostSignol: 25,
      avgNetFuelSavingKgPreSignol: 33.89,
      avgNetFuelSavingKgPostSignol: 43.93,
    },
    {
      countEventsPerformablePostSignol: 127,
      countEventsPerformedPostSignol: 25,
      avgNetFuelSavingKgPreSignol: 39.89,
      avgNetFuelSavingKgPostSignol: 46.93,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 65.09,
      avgNetFuelSavingKgPostSignol: 60.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 70.09,
      avgNetFuelSavingKgPostSignol: 74.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 76.09,
      avgNetFuelSavingKgPostSignol: 65.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 78.09,
      avgNetFuelSavingKgPostSignol: 70.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 79.65,
      avgNetFuelSavingKgPostSignol: 85.09,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 80.65,
      avgNetFuelSavingKgPostSignol: 87.09,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 82.65,
      avgNetFuelSavingKgPostSignol: 90.09,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 84.65,
      avgNetFuelSavingKgPostSignol: 99.09,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 85.09,
      avgNetFuelSavingKgPostSignol: 89.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 86.09,
      avgNetFuelSavingKgPostSignol: 93.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 87.09,
      avgNetFuelSavingKgPostSignol: 95.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 88.09,
      avgNetFuelSavingKgPostSignol: 80.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 89.09,
      avgNetFuelSavingKgPostSignol: 78.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 90.09,
      avgNetFuelSavingKgPostSignol: 95.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 90.09,
      avgNetFuelSavingKgPostSignol: 97.65,
    },
    {
      countEventsPerformablePostSignol: 434,
      countEventsPerformedPostSignol: 427,
      avgNetFuelSavingKgPreSignol: 90.09,
      avgNetFuelSavingKgPostSignol: 92.65,
    },
  ];
};
